module.exports = __webpack_public_path__ + "img/pos-img4.0727ebf9.png";